// extracted by mini-css-extract-plugin
module.exports = {"uploadPage":"upload_uploadPage__3V9Gw","dropTarget":"upload_dropTarget__2nd4k","dropTargetOver":"upload_dropTargetOver__honNT","uploadButton":"upload_uploadButton__gJL6n"};